(function(){
  var HANDLE='casquette-lv-get-ready-2';
  var MIN=3000;
  var upsellShown=false, proceedNow=false, prod=null, capInCart=false, cartTotal=0;
  function money(c){return (c/100).toFixed(2).replace('.',',')+' €';}
  function loadProd(){fetch('/products/'+HANDLE+'.js').then(function(r){return r.json();}).then(function(p){prod=p;}).catch(function(){});}
  loadProd();
  function updateMinMsg(){
    var m=document.getElementById('kinbo-min-msg');
    if(!m)return;
    if(cartTotal>0 && cartTotal<MIN){
      m.innerHTML='Commande minimum <strong>30&nbsp;€</strong> — il te manque <strong>'+money(MIN-cartTotal)+'</strong>';
      m.style.display='block';
    }else{ m.style.display='none'; }
  }
  function refreshCart(cb){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
      cartTotal=c.total_price;
      capInCart=c.items.some(function(i){return i.handle===HANDLE;});
      updateMinMsg();
      if(cb)cb();
    }).catch(function(){if(cb)cb();});
  }
  window.kinboOpenUpsell=function(){
    var ov=document.getElementById('kinbo-upsell-overlay');
    if(!ov||!prod||!prod.variants||!prod.variants.length)return false;
    var v=prod.variants[0];
    var img=document.getElementById('kinbo-upsell-img');
    if(img)img.src=(prod.featured_image||(prod.media&&prod.media[0]&&prod.media[0].src)||'');
    var t=document.getElementById('kinbo-upsell-title');if(t)t.textContent=prod.title;
    var pr=document.getElementById('kinbo-upsell-price');if(pr)pr.textContent=money(v.price);
    var cmp=document.getElementById('kinbo-upsell-compare');
    if(cmp){if(v.compare_at_price&&v.compare_at_price>v.price){cmp.textContent=money(v.compare_at_price);cmp.style.display='';}else{cmp.style.display='none';}}
    ov.style.display='flex';
    return true;
  };
  window.kinboCloseUpsell=function(){var ov=document.getElementById('kinbo-upsell-overlay');if(ov)ov.style.display='none';};
  function proceed(){
    proceedNow=true;
    window.kinboCloseUpsell();
    var b=document.getElementById('kinbo-checkout-btn');
    if(b){b.click();}else{window.location.href='/checkout';}
  }
  window.kinboSkipUpsell=function(){proceed();};
  window.kinboAddUpsell=function(){
    var btn=document.getElementById('kinbo-upsell-add');
    if(!prod||!prod.variants||!prod.variants.length){proceed();return;}
    var v=prod.variants[0];
    if(btn){btn.disabled=true;btn.textContent='Ajout...';}
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:v.id,quantity:1})})
      .then(function(){proceed();}).catch(function(){proceed();});
  };
  function gate(e){
    var b = (e.target && e.target.closest) ? e.target.closest('#kinbo-checkout-btn') : null;
    if(!b) return;
    if(proceedNow) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    refreshCart(function(){
      if(cartTotal<MIN){ updateMinMsg(); return; }
      if(!capInCart && !upsellShown){ upsellShown=true; if(!window.kinboOpenUpsell()){ proceed(); } return; }
      proceed();
    });
  }
  window.addEventListener('click', gate, true);
  document.addEventListener('click', gate, true);
  window.kinboRefreshMin=refreshCart;
  refreshCart();
  document.addEventListener('click',function(ev){
    var t=ev.target;
    if(t&&t.closest&&(t.closest('[data-cart-drawer-open]')||t.closest('a[href="/cart"]'))){setTimeout(refreshCart,700);}
  }, false);
})();

(function(){
  var SOCK_PIDS=[15614720999772,15677701259612,15677701226844];
  var sockInCart=false;
  function wrapEl(){return document.getElementById('cart-upsell-wrap');}
  function enforce(){var w=wrapEl();if(w&&sockInCart&&w.style.display!=='none'){w.style.display='none';}}
  function check(){return fetch('/cart.js').then(function(r){return r.json();}).then(function(c){sockInCart=(c.items||[]).some(function(i){return SOCK_PIDS.indexOf(i.product_id)!==-1;});enforce();}).catch(function(){});}
  function observe(){var w=wrapEl();if(!w||w.__kinboObs)return;w.__kinboObs=true;var mo=new MutationObserver(function(){enforce();});mo.observe(w,{attributes:true,attributeFilter:['style']});}
  function wrapFn(name){var o=window[name];if(typeof o==='function'&&!o.__kinboWrapped){var nf=function(){var r=o.apply(this,arguments);setTimeout(check,150);setTimeout(check,600);return r;};nf.__kinboWrapped=true;window[name]=nf;}}
  function init(){observe();check();wrapFn('addUpsellToCart');wrapFn('updateQty');wrapFn('removeItem');wrapFn('openCartDrawer');wrapFn('loadCart');}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();

(function(){
  /* ---- Order bump chaussettes : petit swipe (clic = glissement) ---- */
  var BUMP_VIDS=[58288227811676,58288227844444,58288227877212];
  var added=false, busy=false;
  var ARROW='<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>';
  var CHECK='<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l5 5L20 7"/></svg>';
  function el(id){return document.getElementById(id);}
  function bumpLine(cart){
    for(var i=0;i<cart.items.length;i++){
      var it=cart.items[i];
      if(BUMP_VIDS.indexOf(it.variant_id)!==-1 && it.properties && it.properties['_bump']) return it;
    }
    return null;
  }
  function selVid(){var s=el('cart-bump-size');return s?parseInt(s.value,10):BUMP_VIDS[1];}
  function showAdded(){
    added=true;
    var b=el('cart-bump');if(b)b.classList.add('cart-bump--added');
    var k=el('cart-bump-knob');if(k)k.innerHTML=CHECK;
    var p=el('cart-bump-pill');if(p)p.setAttribute('aria-label','Retirer les chaussettes');
  }
  function showIdle(){
    added=false;
    var b=el('cart-bump');if(b)b.classList.remove('cart-bump--added');
    var k=el('cart-bump-knob');if(k)k.innerHTML=ARROW;
    var p=el('cart-bump-pill');if(p)p.setAttribute('aria-label','Ajouter les chaussettes');
  }
  window.kinboBumpTap=function(){
    if(busy)return;busy=true;
    if(!added){
      showAdded();
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:selVid(),quantity:1,properties:{_bump:'1'}})})
        .then(function(){busy=false;if(window.loadCart)window.loadCart();})
        .catch(function(){busy=false;showIdle();});
    }else{
      showIdle();
      fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
        var line=bumpLine(c);
        if(line){fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:line.key,quantity:0})}).then(function(){busy=false;if(window.loadCart)window.loadCart();});}
        else{busy=false;}
      }).catch(function(){busy=false;});
    }
  };
  window.kinboBumpSizeChange=function(){
    if(!added){return;}
    if(busy)return;busy=true;
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
      var line=bumpLine(c);
      function add(){fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:selVid(),quantity:1,properties:{_bump:'1'}})}).then(function(){busy=false;if(window.loadCart)window.loadCart();});}
      if(line){fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:line.key,quantity:0})}).then(add);}else{add();}
    }).catch(function(){busy=false;});
  };
  function sync(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
      var box=el('cart-bump');if(!box)return;
      if(!c.items||c.items.length===0){box.style.display='none';return;}
      box.style.display='block';
      var line=bumpLine(c);
      if(line){var s=el('cart-bump-size');if(s)s.value=line.variant_id;showAdded();}else{showIdle();}
      if(window.kinboRefreshMin)window.kinboRefreshMin();
    }).catch(function(){});
  }
  function wrap(){var o=window.loadCart;if(typeof o==='function'&&!o.__bumpWrapped){var nf=function(){var r=o.apply(this,arguments);setTimeout(sync,250);return r;};nf.__bumpWrapped=true;window.loadCart=nf;}}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){wrap();sync();});}else{wrap();sync();}
})();
